export default {
  fields: {
    code: 'Código',
    tag: 'Etiqueta',
    type: 'Tipo',
    discount_type: 'Tipo de descuento',
    discount: 'Descuento',
    usage_threshold: 'Umbral de uso',
    quantity: 'Cantidad',
    expires_at: 'Vence',
    customers: 'Clientes',
    purchases: 'Pedidos',
    sales: 'Ventas',
    level: 'Nivel',
    max_discount: 'Descuento máximo',
  },
  tags: {
    master: 'Maestro',
    campaign: 'Campaña',
    one_time: 'Un solo uso',
  },
  types: {
    single_use: 'Uso único',
    multi_use: 'Uso múltiple',
    unknown: 'Desconocido',
  },
  discount_types: {
    fixed_amount: 'Importe fijo',
    percentage: 'Porcentaje',
    unknown: 'Desconocido',
  },
  labels: {
    discount: 'Descuento',
    usage_threshold: 'Umbral de uso',
    company: 'Empresa',
  },
  collecting_emails: {
    description:
      'Aquí puedes configurar el código promocional de un solo uso generado para nuevos usuarios al registrarse en el sitio web.',
  },
  buttons: {
    edit: 'Editar',
  },
  toasts: {
    successfully_deleted: 'Configuración del código promocional eliminada correctamente',
    failed_to_load_data: 'Error al cargar los datos',
  },
};
